import type { StorageOperationError } from '../../../../../types/azureStorage';
import { AlertTriangle, Lock } from 'lucide-react';
import { Button } from '../../../../../components/ui/button';
import { trackStorageEvent } from '../../services/storageAnalytics';
import type { PolicyDialogTrackEvent, PolicyDialogTrackProps } from './accessPolicyTargets';

/**
 * A failed ACL read is shown with its typed message and a Retry (review C N4), never as empty controls. Final UI/UX
 * batch C1 (N9): the refusal layout's reading — a lock and a short title for a role refusal (an alert icon otherwise),
 * the sentence in foreground text at body size — instead of 12 px text on a red wash.
 */
export function AclReadError({ error, onRetry, trackEvent = 'feature:storage_container_action', trackProps }: { error: StorageOperationError; onRetry: () => void; trackEvent?: PolicyDialogTrackEvent; trackProps?: PolicyDialogTrackProps }) {
  const refused = error.fix?.kind === 'needs-role';
  const Icon = refused ? Lock : AlertTriangle;
  return (
    <div className="space-y-2 rounded-md border border-border bg-muted/30 p-3 text-sm text-foreground" role="alert" data-testid="storage-acl-read-error">
      <p className="flex items-center gap-2 font-medium"><Icon className={refused ? 'h-4 w-4 shrink-0 text-warning' : 'h-4 w-4 shrink-0 text-destructive'} aria-hidden="true" />{refused ? 'This identity cannot read these access settings' : 'The access settings could not be read'}</p>
      <p data-testid="storage-acl-read-error-message">{error.message}</p>
      <Button type="button" size="xs" variant="outline" onClick={() => { trackStorageEvent(trackEvent, { action: 'acl_read_retry', ...trackProps }); onRetry(); }}>Retry</Button>
    </div>
  );
}
